import CustomForm from "../../../components/form/CustomForm";
import PageWrapper from "../../../components/layouts/PageWrapper";
import { useCallback, useMemo } from "react";
import { productTagFields } from "../../../helpers/fields/product/product-tag.fields";
import { productTagSchema } from "../../../helpers/validation-schemas/product/product-tag.schema";
import { useNavigate } from "react-router-dom";
import { useCreateProductTagMutation } from "../../../states/product/product-tag.api";
import { useErrorHandling } from "../../../hooks/useErrorHandling";
import { castTypeArr } from "../../../utils/general/cast-type";
import { TFailResponse } from "../../../types/general/TFailResponse";
import { removeKeys } from "../../../utils/general/removeKeys";
import { createBusinessUnit } from "../../../services/fake-data";
import { TSuccessResponse } from "../../../types/general/TSuccessResponse";
import { Toast } from "../../../helpers/popups/Toast";
import { PRODUCT_TAG } from "../../../utils/constants/product-tag.constants";
import { LoadingSpinner } from "../../../components/layouts/LoadingSpinner";
import AuthComponent from "@components/auth/component";
import { useCreateUserRoleMutation } from "../../../states/user-management/user-role.api";
import { userRoleFields } from "../../../helpers/fields/user-management/user-role.fields";
import { userRoleSchema } from "../../../helpers/validation-schemas/user-management/user-role.schema";
import { USER_ROLE } from "../../../utils/constants/user-role.constants";

const UserRoleAddPage = () => {
  const navigate = useNavigate();

  const [createUserRole, { isLoading, isSuccess, error: createError }] =
    useCreateUserRoleMutation();

  useErrorHandling(...castTypeArr<TFailResponse>([createError]));

  const fields = useMemo(() => {
    return userRoleFields();
  }, []);

  const asyncDispatcher = useCallback(
    async (reqBody: any) => {
      try {
        const rest = removeKeys(reqBody, "remark");
        const res = await createUserRole({
          ...rest,
        });

        const successData = "data" in res ? res.data : null;
        const { success, message } = successData as TSuccessResponse;

        if (success || isSuccess) {
          await Toast.fire({
            title: message,
            icon: "success",
          });

          navigate(USER_ROLE.BASE_PATH, {
            state: {
              reload: true,
            },
          });
        }
      } catch (error) {
        console.log("Error", error);
      }
    },
    [createBusinessUnit, isSuccess, Toast, navigate]
  );

  return (
    <AuthComponent
      action="create"
      module="User Management"
      subModule="User Role"
      page
    >
      <PageWrapper>
        {isLoading && <LoadingSpinner />}
        <CustomForm
          title={USER_ROLE.ADD_NEW_TITLE}
          schema={userRoleSchema}
          fields={fields}
          asyncDispatcher={asyncDispatcher}
        />
      </PageWrapper>
    </AuthComponent>
  );
};

export default UserRoleAddPage;
